import React from "react";
import BannerFormPage from "features/MarketingBanner/presentation/pages/BannerForm";

function BannerCreateScreen() {
  return <BannerFormPage />;
}

export default BannerCreateScreen;
